/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Last_QuarterInputs */

const en_date_last_quarter = /** @type {(inputs: Date_Last_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Quarter`)
};

/**
* | output |
* | --- |
* | "Last Quarter" |
*
* @param {Date_Last_QuarterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const date_last_quarter = /** @type {((inputs?: Date_Last_QuarterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Last_QuarterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_date_last_quarter(inputs)
});